<div class="lead-page">
  <div class="title">
    <p class="vox-heading-2">New Lead</p>
  </div>
  <hr />
  <div class="form-container">
    <form [formGroup]="newLeadForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-sm col-md-5">
          <label for="firstName" translate="">sales.lead.form.firstName.label</label>
          <div class="vox-input-group vox-input-group_dense" [ngClass]="{
              'vox-input-group_invalid': isFieldValid('firstName')
            }">
            <input class="vox-text-field" type="text" id="firstName" formControlName="firstName"
              [placeholder]="'sales.lead.form.firstName.placeholder' | translate" />
            <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
            <span class="vox-input-group__error-message" translate>sales.lead.form.error</span>
          </div>
        </div>
        <div class="col-sm col-md-5">
          <label for="lastName" translate>sales.lead.form.lastName.label</label>
          <div class="vox-input-group vox-input-group_dense" [ngClass]="{
              'vox-input-group_invalid': isFieldValid('lastName')
            }">
            <input class="vox-text-field" type="text" id="lastName" formControlName="lastName"
              [placeholder]="'sales.lead.form.lastName.placeholder' | translate" />
            <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
            <span class="vox-input-group__error-message" translate>sales.lead.form.error</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm col-md-5">
          <label for="company" translate="">sales.lead.form.company.label</label>
          <div class="vox-input-group vox-input-group_dense" [ngClass]="{
              'vox-input-group_invalid': isFieldValid('company')
            }">
            <input class="vox-text-field" type="text" id="company" formControlName="company"
              [placeholder]="'sales.lead.form.company.placeholder' | translate" /><i
              class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
              class="vox-input-group__error-message" translate>sales.lead.form.error</span>
          </div>
        </div>
        <div class="col-sm col-md-5">
          <label for="phoneNumber" translate="">sales.lead.form.phoneNumber.label</label>
          <div class="phone-field vox-input-group_dense" [ngClass]="{
              'vox-input-group_invalid': isFieldValid('phoneNumber')
            }">
            <vox-phone-text-field state="it" formControlName="phoneNumber" [dense]="true"></vox-phone-text-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm col-md-5">
          <label for="email" translate>sales.lead.form.email.label</label>
          <div class="vox-input-group vox-input-group_dense" [ngClass]="{
              'vox-input-group_invalid': isFieldValid('email')
            }">
            <input class="vox-text-field" type="email" id="email" formControlName="email"
              [placeholder]="'sales.lead.form.email.placeholder' | translate" />
            <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
            <span *ngIf="newLeadForm.get('email').errors && newLeadForm.get('email').errors.required"
              class="vox-input-group__error-message" translate>sales.lead.form.error</span>
            <span *ngIf="newLeadForm.get('email').errors && newLeadForm.get('email').errors.pattern"
              class="vox-input-group__error-message" translate>sales.lead.form.email.error</span>
          </div>
        </div>
        <div class="col-sm col-md-5">
          <label for="seats" translate>sales.lead.form.seats.label</label>
          <div class="vox-input-group vox-input-group_dense" [ngClass]="{
              'vox-input-group_invalid': isFieldValid('seats')
            }">
            <input class="vox-text-field" type="number" id="seats" formControlName="seats"
              [placeholder]="'sales.lead.form.seats.placeholder' | translate" /><i
              class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
              class="vox-input-group__error-message" translate>sales.lead.form.error</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm col-md-5">
          <label for="source" translate>sales.lead.form.source.label</label>
          <div ngbDropdown class="vox-dropdown-input">
            <button class="dropdown-toggle" role="button" type="button" data-toggle="dropdown" ngbDropdownToggle>
              {{ sourceToken | translate}}
            </button>
            <div ngbDropdownMenu>
              <a (click)="onChangeSource(source)" type="button" ngbDropdownItem *ngFor="let source of sources">
                {{'sales.lead.form.source.options.' + source | translate}}
              </a>
            </div>
          </div>
        </div>
        <div class="col-sm col-md-5">
          <label for="medium" translate>sales.lead.form.medium.label</label>
          <div ngbDropdown class="vox-dropdown-input">
            <button class="dropdown-toggle" role="button" type="button" data-toggle="dropdown" ngbDropdownToggle>
              {{ mediumToken | translate}}
            </button>
            <div ngbDropdownMenu>
              <a (click)="onChangeMedium(medium)" type="button" ngbDropdownItem *ngFor="let medium of mediums">
                {{'sales.lead.form.medium.options.' + medium | translate}}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="
        newLeadForm.controls.medium.value === 'other' ||
        newLeadForm.controls.source.value === 'other'
        ">
        <div class="col-sm col-md-5 selected-source">
          <div class="vox-input-group vox-input-group_dense"
            [ngClass]="{ 'vox-input-group_invalid': newLeadForm.errors && newLeadForm.errors.source }"
            *ngIf="newLeadForm.controls.source.value === 'other'">
            <input class="vox-text-field" type="text" formControlName="customSource"
              [placeholder]="'sales.lead.form.source.placeholder' | translate" />
            <span class="vox-input-group__error-message" translate>sales.lead.form.error</span>
          </div>
        </div>
        <div class="col-sm col-md-5 selected-medium">
          <div class="vox-input-group vox-input-group_dense"
            [ngClass]="{ 'vox-input-group_invalid': newLeadForm.errors && newLeadForm.errors.medium }"
            *ngIf="newLeadForm.controls.medium.value === 'other'">
            <input class="vox-text-field medium-field" type="text" formControlName="customMedium"
              [placeholder]="'sales.lead.form.medium.placeholder' | translate" />
            <span class="vox-input-group__error-message" translate>sales.lead.form.error</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm col-md-5">
          <label for="info" translate>sales.lead.form.country.label</label>
          <vox-select-country [language]="language" [searchEnabled]="false" [dense]="true" [countryList]="countryList"
            formControlName="country">
          </vox-select-country>
        </div>


        <div class="col-sm col-md-5">
          <label for="info" translate>sales.lead.form.referralCode.label</label>
          <div class="vox-input-group vox-input-group_dense">
            <input class="vox-text-field" id="referralCode" formControlName="referralCode"
              [placeholder]="'sales.lead.form.referralCode.placeholder' | translate" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm col-md-10">
          <label for="info" translate>sales.lead.form.notes.label</label>
          <div class="vox-input-group_dense">
            <textarea class="vox-text-field" id="info" formControlName="info" rows="5"
              [placeholder]="'sales.lead.form.notes.placeholder' | translate"></textarea>
          </div>
        </div>
      </div>
      <div class="submit-container">
        <button class="vox-btn vox-btn-primary" [ladda]="loading" type="submit" [disabled]="newLeadForm.invalid">
          {{'sales.lead.form.submit' | translate}}
        </button>
      </div>
    </form>
  </div>
</div>